import { List } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AlertIcon from 'assets/membership-features/alert.svg?react';
import ElectricIcon from 'assets/membership-features/electric.svg?react';
import ForecastIcon from 'assets/membership-features/forecast.svg?react';
import FireIcon from 'assets/membership-features/logo.svg?react';
import MapIcon from 'assets/membership-features/map.svg?react';
import MoneyIcon from 'assets/membership-features/money.svg?react';
import RadioIcon from 'assets/membership-features/radio.svg?react';
import TankerIcon from 'assets/membership-features/tanker.svg?react';
import FloodIcon from 'assets/membership-features/flood.svg?react';
import PlaceIcon from 'assets/membership-features/place.svg?react';
import { MembershipPlan } from '../../../membership.constants';
import { FeatureItem } from './FeatureItem';

type FeatureListProps = {
  plan?: MembershipPlan | 'teams';
};

export const FeatureList = (props: FeatureListProps): JSX.Element => {
  const { plan } = props;
  const { t } = useTranslation();

  if (plan === 'teams') {
    return (
      <List dense disablePadding>
        <FeatureItem
          label={t('supportUs.features.orgManagement')}
          Icon={FireIcon}
        />
        <FeatureItem
          label={t('supportUs.features.teamBilling')}
          Icon={AlertIcon}
        />
        <FeatureItem
          label={t('supportUs.features.membershipDiscounts')}
          Icon={MoneyIcon}
        />
        <FeatureItem
          label={t('supportUs.features.gisImport')}
          Icon={MapIcon}
          comingSoon
        />
      </List>
    );
  }

  if (plan === 'yearly') {
    return (
      <List dense disablePadding>
        <FeatureItem
          label={t('supportUs.features.volunteerReports')}
          Icon={FireIcon}
        />
        <FeatureItem
          label={t('supportUs.features.aircraftTracking')}
          Icon={TankerIcon}
        />
        <FeatureItem
          label={t('supportUs.features.countyAlerts')}
          Icon={AlertIcon}
        />
        <FeatureItem
          label={t('supportUs.features.weatherAlerts')}
          Icon={FloodIcon}
        />
      </List>
    );
  }

  return (
    <List dense disablePadding>
      <FeatureItem
        label={t('supportUs.features.aircraftTracking')}
        Icon={TankerIcon}
      />
      <FeatureItem
        label={t('supportUs.features.countyAlerts')}
        Icon={AlertIcon}
      />
      <FeatureItem
        label={t('supportUs.features.criticalInfrastructure')}
        Icon={ElectricIcon}
      />
      <FeatureItem
        label={t('supportUs.features.evacuationZones')}
        Icon={MapIcon}
      />
      <FeatureItem
        label={t('supportUs.features.privateLandOwnership')}
        Icon={PlaceIcon}
      />
      <FeatureItem
        label={t('supportUs.features.radioChannels')}
        Icon={RadioIcon}
      />
      <FeatureItem
        label={t('supportUs.features.fireModels')}
        Icon={ForecastIcon}
      />
    </List>
  );
};
